import { useCallback, useState } from "react"

import ProductCard from "./product-card"
import ProductDetailsDialog from "./product-details-dialog"
import defaultProducts from "./products"

const ProductCards = ({ products = defaultProducts }) => {
  const [dialogData, setDialogData] = useState(null)

  const handleCardClick = useCallback((details) => {
    setDialogData(details)
  }, [])

  const handleDialogDismiss = useCallback(() => {
    setDialogData(null)
  }, [])

  if (products.length === 0) return null

  return (
    <>
      {products.map((product, index) => (
        <ProductCard
          key={index}
          onClick={() => handleCardClick(product.details)}
          {...product}
          sx={{
            "&:not(:last-of-type)": {
              mb: [2, 3],
            },
          }}
        />
      ))}
      <ProductDetailsDialog
        {...dialogData}
        isOpen={Boolean(dialogData)}
        onDismiss={handleDialogDismiss}
      />
    </>
  )
}

export default ProductCards
